// PurchaseOrderTerms.jsx

import React from 'react';

import PurchaseOrderRichTextSection from 'nodetypes/purchaseorder/view/PurchaseOrderRichTextSection';

/**
 * PurchaseOrderTerms
 *
 * Terms and Conditions richtext section for the PURCHASE_ORDER viewer.
 */
const PurchaseOrderTerms = React.memo(({
  node,
  nodeType = null,
  readOnly = false,
  onNodeChange = null,
}) => (
  <PurchaseOrderRichTextSection
    node={node}
    nodeType={nodeType}
    readOnly={readOnly}
    onNodeChange={onNodeChange}
    fieldName="termsAndConditions"
    title="Terms and Conditions"
    emptyLabel="No terms and conditions."
  />
));

PurchaseOrderTerms.displayName = 'PurchaseOrderTerms';

export default PurchaseOrderTerms;
